import { FC } from 'react';

import { useFormik } from 'formik';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import css from './LevelFormDialog.module.css';

import { RewardsFormControl } from 'v2/components/form/rewardsFormControl/RewardsFormControl';
import { LevelForm } from 'v2/types/LevelModel';

interface LevelFormDialogProps {
  title: string;
  isOpen: boolean;
  onClose: VoidFunction;
  initialValues: LevelForm;
  isSubmitting: boolean;
  level: number;
  onSubmit: (values: LevelForm, resetForm: VoidFunction) => void;
}

export const LevelFormDialog: FC<LevelFormDialogProps> = ({
  title,
  isOpen,
  onClose,
  initialValues,
  isSubmitting,
  level,
  onSubmit,
}) => {
  const formik = useFormik<LevelForm>({
    initialValues,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values, resetForm);
    },
    enableReinitialize: true,
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" scroll="paper" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <form id="levelForm" className="form" onSubmit={formik.handleSubmit}>
          <div className={css.levelFormCurrent}>{level}</div>

          <TextField
            name="levelPoints"
            value={formik.values.levelPoints}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Level Points"
            type="number"
            required
          />

          <div className="form-group">
            <TextField
              name="dailyBonusPercent"
              value={formik.values.dailyBonusPercent}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Daily Bonus, %"
              type="number"
              required
              fullWidth
            />

            <TextField
              name="referralBonusPercent"
              value={formik.values.referralBonusPercent}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Referral Bonus, %"
              type="number"
              required
              fullWidth
            />
          </div>

          <RewardsFormControl formik={formik} withCount />
        </form>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="error" variant="outlined">
          Cancel
        </Button>

        <Button form="levelForm" type="submit" variant="contained" loading={isSubmitting}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
